
import { mapGetters, mapState, mapActions } from 'vuex';
import WIcon from '~/components/ui/icons/WIcon.vue';
import ProfileImg from '~/components/ui/atom/ProfileImg.vue';
import Portfolios from '~/components/shared/nav/header/portfolios/index.vue';
import Notifications from '~/components/shared/nav/header/notifications/index.vue';
import Help from '~/components/shared/nav/header/help/index.vue';
import { getWindowInstance } from '~/plugins/windowInstance';
import { appURLs, inAppRedirect } from '~/utils/route-redirects';
import { isMobileResponsive } from '~/utils/mixins';
import { ComponentIds } from '~/utils/componentIds';

// TODO this component should be renamed and refactored. The name "NavProfile" does not match this component's purpose or behavior.
export default {
  name: 'NavProfile',
  components: {
    Notifications,
    Portfolios,
    ProfileImg,
    WIcon,
    Help,
  },
  mixins: [isMobileResponsive],
  props: {
    showHelpCenter: {
      type: Boolean,
      required: true,
    },
    showSendMessageButton: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  async fetch() {
    await this.getMyPortfolios();
  },
  computed: {
    ...mapState('ui-messaging', ['pageActionIcon']),
    ...mapGetters('authentication', ['profile', 'uploadProfileAvatarSuccess']),
    ...mapGetters('messaging', ['messageNotificationCount']),
    sanitizedNotificationCount() {
      return this.messageNotificationCount ?? 0;
    },

    profilePicAlt() {
      return this.$t('posession', {
        subj: this.profile.displayName,
        obj: this.$t('profile_picture'),
      });
    },

    actionIcon() {
      if (!['sm'].includes(this.$mq)) {
        return 'profile';
      }
      return this.pageActionIcon;
    },

    profileUrl() {
      return appURLs.profileById(this.profile.profileId);
    },

    isAboveXlResponsive() {
      return getWindowInstance(this).isAboveXlResponsive();
    },

    appUrlsLocalized() {
      return {
        messages: this.localePath(appURLs.messages()),
      };
    },

    helpButtonId() {
      return ComponentIds.HelpIconId;
    },
  },
  methods: {
    ...mapActions('portfolio', ['getMyPortfolios']),

    openMessagesPage(route) {
      inAppRedirect(route);
    },
  },
};
